import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { SessionContext, getSessionCookie, setSessionCookie } from "./session.ts";
class Footer extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div></div>
        );
    }
}
export default withRouter(Footer);